import styled from "styled-components";
import { colors, spacing } from "design-system/foundation";
import { zIndex } from "styles";

export const FullscreenOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.modal + 2};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing["2xl"]};
  background: rgba(24, 27, 37, 0.9);
`;

export const FullscreenImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
`;

export const FullscreenCloseButton = styled.button`
  position: absolute;
  top: ${spacing["2xl"]};
  right: ${spacing["2xl"]};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.xs};
  border: none;
  background: transparent;
  color: ${colors.icon.base.invert};
  cursor: pointer;

  .icon {
    display: flex;
    font-size: 24px;
  }
`;
